import React from 'react';
import util from 'Utils/commonUtil';

class BaseImageUploader extends React.Component {
    element = null;
    singleTapMovedFlag = false;

    getProps() {
        let props = {};

        Object.keys(this.props).forEach((prop) => {
            if (
                (prop === 'onClickOfSingleTap' ||
                    prop === 'isPreventDefault' ||
                    prop === 'isStopPropagation' ||
                    prop === 'children') &&
                prop === 'disabled'
            )
                return;
            props[prop] = this.props[prop];
        });

        props = {
            ...props,
            ...util.clickOfSingleTap(
                (ev) => {
                    if (this.props.disabled) return;
                    this.props.onClickOfSingleTap &&
                        this.props.onClickOfSingleTap(ev);
                },
                {
                    isPreventDefault: this.props.isPreventDefault,
                    isStopPropagation: this.props.isStopPropagation,
                },
            ),
        };

        return props;
    }

    render() {
        let {tag, children} = this.props;

        this.element = React.createElement(
            tag || 'a',
            this.getProps(),
            children,
        );

        return <React.Fragment>{this.element}</React.Fragment>;
    }
}

export default BaseImageUploader;
